// ---------------------------------------------------------------------------
// Presets de período — traduzem um chip ("Este mês") num par `from`/`to`.
//
// ⚠️ A âncora é SEMPRE o `reference_date` que o backend devolve, nunca o relógio
// do navegador (0084 §5.4: o fuso do domínio é America/Sao_Paulo e o cliente
// pode estar em outro). Sem referência, os presets não são calculáveis e os
// chips ficam desabilitados — exceto `tudo`, que é a ausência de recorte e não
// precisa de âncora.
// ---------------------------------------------------------------------------

import {
   addDaysIso,
   startOfMonthIso,
   startOfYearIso,
} from './format';
import { ORIGIN_COVERAGE_START } from '../constants';

// Devolve { from, to } — strings vazias quando o preset não recorta.
export function computePeriodRange(key, referenceDate) {
   if (key === 'tudo') return { from: '', to: '' };
   if (!referenceDate) return null;

   const to = referenceDate;

   switch (key) {
      case 'este_mes':
         return { from: startOfMonthIso(referenceDate), to };
      // "90 dias" = janela de 90 dias INCLUSIVA (hoje conta), por isso -89.
      case '90_dias':
         return { from: addDaysIso(referenceDate, -89), to };
      case 'este_ano':
         return { from: startOfYearIso(referenceDate), to };
      case 'desde_mar_2026':
         return { from: ORIGIN_COVERAGE_START, to };
      default:
         return null;
   }
}

// Caminho inverso: dado o que está na URL, qual chip acende? Nenhum, se o
// operador digitou datas próprias — recorte manual não finge ser preset.
export function detectPeriodKey({ from, to }, referenceDate, presetKeys) {
   if (!from && !to) return 'tudo';

   const match = presetKeys.find((key) => {
      if (key === 'tudo') return false;
      const range = computePeriodRange(key, referenceDate);
      return range && range.from === from && range.to === to;
   });

   return match ?? null;
}
